import { Injectable } from '@angular/core';
import { FaBrands } from './interfaces/fa-brands.interface';
import { FaRegular } from './interfaces/fa-regular.interface';
import { FaSolid } from './interfaces/fa-solid.interface';
import { faBrands } from './constants/fa-brands.constant';
import { faRegular } from './constants/fa-regular.constant';
import { faSolid } from './constants/fa-solid.constant';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  brands: FaBrands = faBrands;
  regular: FaRegular = faRegular;
  solid: FaSolid = faSolid;
}
